import * as Yup from "yup";
import {
  emailValidation,
  phoneValidation,
  fullNameValidation,
} from "../../../Utils/ValidationSchema";

const HHMM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

const openingHoursDaySchema = (t) =>
  Yup.object({
    dayOfWeek: Yup.number().min(1).max(7).required(),
    enabled: Yup.boolean(),
    // Per COMY1-279 AC #4 (Roei: "any hours allowed") and AC #5 (empty
    // From/To = 24h open), there is no day-level range check. Each field
    // only needs to be a valid HH:MM if a value is provided.
    openTime: Yup.string()
      .nullable()
      .test("hhmm", t("validation-error-messages:invalid_time"), (v) =>
        v == null || v === "" ? true : HHMM_REGEX.test(v)
      ),
    closeTime: Yup.string()
      .nullable()
      .test("hhmm", t("validation-error-messages:invalid_time"), (v) =>
        v == null || v === "" ? true : HHMM_REGEX.test(v)
      ),
  });

const deliveryAreaSchema = () =>
  Yup.object({
    districtId: Yup.number().required(),
    // Allow null — UI uses null as "empty / use the 0 default". The backend
    // coerces null to 0 before insert.
    deliveryCost: Yup.number().min(0).nullable(),
    currency: Yup.number().required(),
  });

const fulfillmentSchema = (t) =>
  Yup.object({
    pickup: Yup.object({
      enabled: Yup.boolean(),
      address: Yup.mixed().nullable(),
      minPickupTime: Yup.number().nullable().min(0),
      // time_units: 4=minutes, 1=hours, 2=days, 3=weeks
      minPickupTimeUnit: Yup.number().nullable().oneOf([1, 2, 3, 4]),
      useStoreSchedule: Yup.boolean(),
      customSchedule: Yup.array().of(
        Yup.object({
          dayOfWeek: Yup.number().min(1).max(7).required(),
          // Nullable + HH:MM only when present (overnight + 24h allowed).
          openTime: Yup.string()
            .nullable()
            .test("hhmm", t("validation-error-messages:invalid_time"), (v) =>
              v == null || v === "" ? true : HHMM_REGEX.test(v)
            ),
          closeTime: Yup.string()
            .nullable()
            .test("hhmm", t("validation-error-messages:invalid_time"), (v) =>
              v == null || v === "" ? true : HHMM_REGEX.test(v)
            ),
        })
      ),
    }),
    delivery: Yup.object({
      estimatedDeliveryTime: Yup.number().nullable().min(0),
      estimatedDeliveryTimeUnit: Yup.number().nullable().oneOf([1, 2, 3, 4]),
      areas: Yup.array().of(deliveryAreaSchema()),
    }),
  });

const validationSchema = (t) =>
  Yup.object({
    contactFullName: fullNameValidation(),
    contactPhoneNumber: phoneValidation(),
    contactEmail: emailValidation(),
    description: Yup.string()
      .optional()
      .max(200, t("validation-error-messages:description_max")),
    afterHoursPrice: Yup.string().when("afterHoursPriceEnabled", {
      is: true,
      then: (schema) =>
        schema
          .required(t("validation-error-messages:after_hours_price_required"))
          .test(
            "positive",
            t("validation-error-messages:valid_after_hours_price"),
            (value) => value > 0
          ),
      otherwise: (schema) => schema.optional(),
    }),
    afterHoursPriceEnabled: Yup.boolean(),
    openingHours: Yup.array().of(openingHoursDaySchema(t)),
    storeSettings: fulfillmentSchema(t),
    restaurantSettings: fulfillmentSchema(t),
  });
export default validationSchema;
